import InputMask from 'react-input-mask'
import TextField from '@material-ui/core/TextField'
import React from 'react'

export const PhoneInput = (props) => {
  return (
    <InputMask {...props} mask='+7(999)-999-99-99'>
      {() => (
        <TextField
          variant='filled'
          size='small'
          required
          fullWidth
          label='Номер телефона'
        />
      )}
    </InputMask>
  )
}
